( function ( _s ) {
	_s( document ).ready( () => {
		window.getRootProperty = propertyName => {
			const r = document.querySelector( ':root' );
			const rs = getComputedStyle( r );

			return rs.getPropertyValue( propertyName );
		};

		window.setRootProperty = ( propertyName, propertyValue ) => {
			const r = document.querySelector( ':root' );

			r.style.setProperty( propertyName, propertyValue );
		};
	} );
} )( window._s );
